import ScrollNavbar from "reusables/layouts/ScrollNavbar";

function WorkforceNavbar() {
  return <ScrollNavbar title="Workforce" />;
}

export default WorkforceNavbar;
